import React, { useEffect, useState, useContext, useCallback } from 'react';
import { RouteComponentProps } from '@reach/router';
import {
    LayoutStandardCrud,
    BlockLoading2,
    FiltersDisplay,
    loadingWrapperOver,
    AntButton,
} from '@/components';
import { message } from 'antd';
import _ from 'lodash';
import { StoreContext } from '@/stores';
import { useNet, useBeforeFirstDataLoaded } from '@/utils';
import { observer } from 'mobx-react-lite';
import DemoTable from './components/table';
import { EquityDetail } from './components/equity-detail';
import { ActionExe } from './components/exe';
import { runInAction } from 'mobx';
import { dFilterHOC, useDefaultDFilterSnippets } from '@/containers/hoc';
import './index.scss';
import { FinalProcessFormProxy } from '@/pages/sales-follow-up/process/list/form-proxy';
import { genContractProductParamByMis } from './store';
import { CtxProvider } from '@/utils/context';
import { ActionExport } from '@/pages/sales-follow-up/activation-record/list/components/export';

const DemoList: React.FC<RouteComponentProps & {
    type: string;
    dfilters?: any;
}> = ({ type = 'all', dfilters }) => {
    const store = useContext(StoreContext);
    const [defaultStore] = useState(() => new store.ContractProductListStore());
    const userStore = store.getAuthStore();

    const ack = dtext('crm')('contract_product-list-message-' + type, '');

    const {
        defaultPagination,
        defaultSorter,
        defaultMeta,
        pageTitle,
        defaultPerm,
        defaultFilter,
        defaultMSelect,
        defaultFastFilters,
        condListbyFilterData,
    } = defaultStore;

    const { confirmedfilterData } = defaultFilter;

    const { paginationForFetch } = defaultPagination;

    const { sortersForFetch } = defaultSorter;

    const listFetch = useCallback(() => defaultStore.fetch(), []);
    const [error, loading, reload] = useNet(listFetch, {
        autoLoad: false,
        refreshKeys: ['contract_product', 'raw-process'],
    });

    const [preRequiredReady, setPreRequiredReady] = useState(false);
    // 翻页
    useEffect(() => {
        // 元信息，准备用户可查询的
        if (!preRequiredReady) {
            return;
        }
        reload();
    }, [
        paginationForFetch,
        sortersForFetch,
        condListbyFilterData,
        preRequiredReady,
    ]);

    useEffect(() => {
        if (userStore.userInfo) {
            defaultMeta.setTableId('contract_product');
            defaultMeta.setOpUsername(userStore.userInfo.userId + '-' + type);
            defaultFastFilters.setFilters(dfilters);
            Promise.all([defaultMeta.fetch(), defaultPerm.fetch()])
                .then(() => {
                    setPreRequiredReady(true);
                })
                .catch(() => {});
        }
    }, [userStore.userInfo]);

    // 设置filter初始值
    useEffect(() => {
        if (defaultMeta.inited) {
            defaultFilter.resetFilterData();
            defaultFilter.confirmFilterData();
        }
    }, [defaultMeta.inited]);

    useEffect(() => {
        runInAction(() => {
            defaultFastFilters.setType(type);
            defaultStore.setListType(type);
        });
    }, [type]);

    const [isBeforeFirstLoaded] = useBeforeFirstDataLoaded(defaultStore);

    const { title, fastFilters } = useDefaultDFilterSnippets(defaultStore);

    // if (!preRequiredReady) {
    //     return <BlockLoading2 />;
    // }
    const finalLoading = isBeforeFirstLoaded || !preRequiredReady;

    const filtersDisplay = (
        <FiltersDisplay
            objectMeta={defaultMeta.objectMeta}
            filterData={confirmedfilterData}
            sorterData={defaultStore.defaultSorter}
            onClose={(key: string) => {
                defaultFilter.onFilterClear(key);
            }}
        />
    );

    const popups = (
        <>
            <CtxProvider
                ctx={{ position: 'list', positionDetail: 'contract-product' }}
            >
                <FinalProcessFormProxy
                    visible={defaultStore.actionType === 'start-process'}
                    onClose={() => {
                        defaultStore.setMutatingData(null);
                        defaultStore.resetAction();
                    }}
                    key={
                        defaultStore.actionType === 'start-process'
                            ? 'opened'
                            : 'nooppened'
                    }
                    processKey={'productopen'}
                    lifeCycle={{
                        onClose: store => {
                            store.setMutatingData(null);
                            defaultStore.setFillInContractProductProcessObjData(
                                null,
                            );
                        },
                        onOpen: store => {
                            if (
                                !defaultStore.fillInContractProductProcessObjData
                            ) {
                                return;
                            }
                            const {
                                fillInContractProductProcessObjData: data,
                            } = defaultStore;
                            store.startNewData();
                            store.setMutatingData(
                                _.assign(
                                    store.mutatingData,
                                    { talent_bank_version: 0 },
                                    data,
                                ),
                            );
                        },
                    }}
                    preRequestReady={
                        !defaultStore.fillInContractProductProcessObjLoading
                    }
                />
            </CtxProvider>
            <CtxProvider
                ctx={{ position: 'list', positionDetail: 'contract-product' }}
            >
                <FinalProcessFormProxy
                    visible={defaultStore.actionType === 'start-process-guzhu'}
                    onClose={() => {
                        defaultStore.setMutatingData(null);
                        defaultStore.resetAction();
                    }}
                    key={
                        defaultStore.actionType === 'start-process-guzhu'
                            ? 'opened'
                            : 'nooppened'
                    }
                    processKey={'contractemployer'}
                    lifeCycle={{
                        onClose: store => {
                            store.setMutatingData(null);
                            defaultStore.setFillInContractProductGuzhuProcessObjData(
                                null,
                            );
                        },
                        onOpen: store => {
                            if (
                                !defaultStore.fillInContractProductGuzhuProcessObjData
                            ) {
                                return;
                            }
                            const {
                                fillInContractProductGuzhuProcessObjData: data,
                            } = defaultStore;
                            store.startNewData();
                            store.setMutatingData(
                                _.assign(
                                    store.mutatingData,
                                    { talent_bank_version: 0 },
                                    data,
                                ),
                            );
                        },
                    }}
                    preRequestReady={
                        !defaultStore.fillInContractProductGuzhuProcessObjLoading
                    }
                />
            </CtxProvider>
            <EquityDetail defaultStore={defaultStore} />
            <ActionExe defaultStore={defaultStore} />
            <ActionExport defaultStore={defaultStore} />
        </>
    );

    const globalOps = (
        <>
            {defaultPerm.getPermByTypeAndAction(defaultStore.listType)(
                'contract-product-export',
            ).visible && (
                <AntButton
                    onClick={() => {
                        defaultStore.setAction('export');
                    }}
                    size="large"
                >
                    导出
                </AntButton>
            )}
        </>
    );

    const multipleOps = null;

    const dataTable = (
        <DemoTable
            defaultStore={defaultStore}
            loading={loading}
            reload={reload}
        />
    );

    const layoutComs = {
        popups,
        title,
        globalOps,
        filters: filtersDisplay,
        multipleOps,
        dataTable,
        message: null, // ack ? <Alert closable message={ack} /> : null,
        filtersDisplay: fastFilters,
    };

    return loadingWrapperOver(finalLoading)(
        <LayoutStandardCrud className="page-customer-list" {...layoutComs} />,
    );
};

const FinalDemoList = dFilterHOC(observer(DemoList), 'contract_product');
export default FinalDemoList;
